import React, { useEffect, useState } from "react";
import "./memberView.css";

import {
  updateMember,
  getKanda,
  getJumuia,
} from "../../services/api";

import { toast } from "react-toastify";
import { getCurrentUser } from "../../services/auth";

/* ✅ MOVE OUTSIDE COMPONENT */
function Field({ label, children }) {
  return (
    <div className="field">
      <span className="field-label">{label}</span>
      {children}
    </div>
  );
}

export default function MemberEditModal({
  member,
  onClose,
  onUpdated,
}) {
  const user = getCurrentUser();

  const [saving, setSaving] = useState(false);

  const [kandaList, setKandaList] = useState([]);
  const [jumuiaList, setJumuiaList] = useState([]);

  const [form, setForm] = useState({});

  /* ✅ ONLY SYNC WHEN MEMBER CHANGES */
  useEffect(() => {
    if (!member) return;

    setForm({
      ...member,
    });
  }, [member]);

  const formatDate = (value) => {
    if (!value) return "";

    try {
      return new Date(value).toISOString().split("T")[0];
    } catch {
      return "";
    }
  };

  useEffect(() => {
    loadKanda();
  }, []);

  useEffect(() => {
    if (form.kanda_id) {
      loadJumuia(form.kanda_id);
    }
  }, [form.kanda_id]);

  const loadKanda = async () => {
    try {
      const res = await getKanda(user.parokiaId);

      setKandaList(
        Array.isArray(res.data) ? res.data : []
      );
    } catch (err) {
      console.error(err);
    }
  };

  const loadJumuia = async (kandaId) => {
    try {
      const res = await getJumuia(
        user.parokiaId,
        kandaId
      );

      setJumuiaList(
        Array.isArray(res.data) ? res.data : []
      );
    } catch (err) {
      console.error(err);
    }
  };

  const setField = (key, value) => {
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSave = async () => {
    try {
      setSaving(true);

      await updateMember(member.member_id, {
        kandaId: form.kanda_id,
        jumuiaId: form.jumuia_id,

        firstName: form.first_name,
        middleName: form.middle_name,
        surname: form.surname,

        gender: form.gender,

        dateOfBirth: formatDate(form.date_of_birth),

        phone: form.phone,
        backupPhone: form.backup_phone,

        maritalStatus: form.marital_status,

        residenceArea: form.residence_area,
        address: form.address,

        countryName: form.country_name,
        regionName: form.region_name,
        districtName: form.district_name,

        isStudent: form.is_student,
        isJumuiaLeader: form.is_jumuia_leader,

        eventName: form.event_name,
        ageGroup: form.age_group,

        notes: form.notes,
        status: form.status,
      });

      toast.success("Member updated successfully");

      onUpdated?.();
      onClose?.();
    } catch (err) {
      console.error(err);

      toast.error(
        err?.response?.data?.message ||
          "Failed to update member"
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay member-modal-overlay">
      <div className="modal enterprise-modal member-modal">
        <div className="modal-header">
          <h3>Edit Member</h3>

          <button
            className="modal-close"
            onClick={onClose}
          >
            ✕
          </button>
        </div>

        <div className="modal-body">
          <section className="section-card">
            <div className="grid">
              <Field label="First Name">
                <input
                  className="input"
                  value={form.first_name || ""}
                  onChange={(e) =>
                    setField(
                      "first_name",
                      e.target.value
                    )
                  }
                />
              </Field>

              <Field label="Middle Name">
                <input
                  className="input"
                  value={form.middle_name || ""}
                  onChange={(e) =>
                    setField(
                      "middle_name",
                      e.target.value
                    )
                  }
                />
              </Field>

              <Field label="Surname">
                <input
                  className="input"
                  value={form.surname || ""}
                  onChange={(e) =>
                    setField("surname", e.target.value)
                  }
                />
              </Field>

              <Field label="Phone">
                <input
                  className="input"
                  value={form.phone || ""}
                  onChange={(e) =>
                    setField("phone", e.target.value)
                  }
                />
              </Field>

              <Field label="Backup Phone">
                <input
                  className="input"
                  value={form.backup_phone || ""}
                  onChange={(e) =>
                    setField(
                      "backup_phone",
                      e.target.value
                    )
                  }
                />
              </Field>

              <Field label="Gender">
                <select
                  className="input"
                  value={form.gender || "MALE"}
                  onChange={(e) =>
                    setField("gender", e.target.value)
                  }
                >
                  <option value="MALE">Male</option>

                  <option value="FEMALE">
                    Female
                  </option>
                </select>
              </Field>

              <Field label="Date of Birth">
                <input
                  type="date"
                  className="input"
                  value={formatDate(
                    form.date_of_birth
                  )}
                  onChange={(e) =>
                    setField(
                      "date_of_birth",
                      e.target.value
                    )
                  }
                />
              </Field>

              <Field label="Marital Status">
                <input
                  className="input"
                  value={form.marital_status || ""}
                  onChange={(e) =>
                    setField(
                      "marital_status",
                      e.target.value
                    )
                  }
                />
              </Field>

              <Field label="Residence Area">
                <input
                  className="input"
                  value={form.residence_area || ""}
                  onChange={(e) =>
                    setField(
                      "residence_area",
                      e.target.value
                    )
                  }
                />
              </Field>

              <Field label="Address">
                <input
                  className="input"
                  value={form.address || ""}
                  onChange={(e) =>
                    setField("address", e.target.value)
                  }
                />
              </Field>

              <Field label="Country">
                <input
                  className="input"
                  value={form.country_name || ""}
                  onChange={(e) =>
                    setField(
                      "country_name",
                      e.target.value
                    )
                  }
                />
              </Field>

              <Field label="Region">
                <input
                  className="input"
                  value={form.region_name || ""}
                  onChange={(e) =>
                    setField(
                      "region_name",
                      e.target.value
                    )
                  }
                />
              </Field>

              <Field label="District">
                <input
                  className="input"
                  value={form.district_name || ""}
                  onChange={(e) =>
                    setField(
                      "district_name",
                      e.target.value
                    )
                  }
                />
              </Field>

              <Field label="Kanda">
                <select
                  className="input"
                  value={form.kanda_id || ""}
                  onChange={(e) =>
                    setField(
                      "kanda_id",
                      e.target.value
                    )
                  }
                >
                  <option value="">
                    Select Kanda
                  </option>

                  {kandaList.map((k) => (
                    <option
                      key={k.kanda_id}
                      value={k.kanda_id}
                    >
                      {k.kanda_name}
                    </option>
                  ))}
                </select>
              </Field>

              <Field label="Jumuiya">
                <select
                  className="input"
                  value={form.jumuia_id || ""}
                  onChange={(e) =>
                    setField(
                      "jumuia_id",
                      e.target.value
                    )
                  }
                >
                  <option value="">
                    Select Jumuiya
                  </option>

                  {jumuiaList.map((j) => (
                    <option
                      key={j.jumuia_id}
                      value={j.jumuia_id}
                    >
                      {j.jumuia_name}
                    </option>
                  ))}
                </select>
              </Field>

              <Field label="Event Name">
                <input
                  className="input"
                  value={form.event_name || ""}
                  onChange={(e) =>
                    setField(
                      "event_name",
                      e.target.value
                    )
                  }
                />
              </Field>

              <Field label="Age Group">
                <input
                  className="input"
                  value={form.age_group || ""}
                  onChange={(e) =>
                    setField(
                      "age_group",
                      e.target.value
                    )
                  }
                />
              </Field>

              <Field label="Status">
                <input
                  className="input"
                  value={form.status || ""}
                  onChange={(e) =>
                    setField("status", e.target.value)
                  }
                />
              </Field>

              <Field label="Notes">
                <textarea
                  className="input"
                  rows={4}
                  value={form.notes || ""}
                  onChange={(e) =>
                    setField("notes", e.target.value)
                  }
                />
              </Field>
            </div>
          </section>
        </div>

        <div className="modal-footer">
          {/* <button
            className="btn"
            onClick={onClose}
          >
            Cancel
          </button> */}

          <button
            className="btn primary"
            onClick={handleSave}
            disabled={saving}
          >
            {saving
              ? "Saving..."
              : "Save Changes"}
          </button>
        </div>
      </div>
    </div>
  );
}